import React, {Fragment } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Subtitle2, Body2 } from 'components/Typography';

function LocationPicker(props) {
    const { IconComponent } = props;
    return (
        <ListItem button={!props.disabled} onClick={props.disabled ? null : props.onSelectionChanged}>
            <ListItemIcon>
                <IconComponent className={props.avatarClass} />
            </ListItemIcon>
            <Fragment>
                {props.selected && props.selected[props.displayProp] &&
                    <ListItemText>
                        <Subtitle2>
                            {props.selected[props.displayProp]}
                        </Subtitle2>
                        <Body2>
                            {props.pickerName}
                        </Body2>
                    </ListItemText>
                }
                {(!props.selected || !props.selected[props.displayProp]) &&
                    <ListItemText>
                        <Subtitle2>
                            Select
                        </Subtitle2>
                        <Body2>
                            {props.pickerName}
                        </Body2>
                    </ListItemText>

                }
                {!props.disabled &&
                    <ListItemSecondaryAction>
                        <IconButton aria-label="Select" onClick={props.onSelectionChanged}>
                            <ChevronRightIcon />
                        </IconButton>
                    </ListItemSecondaryAction>
                }
            </Fragment>
        </ListItem>
    );
}

export default LocationPicker;